import React, { Fragment, useEffect } from "react";
import "../styles/studentPiq.scss";
import StudentLayout from "../component/reusable/ProfileLayout.js";
import { studentSidebarLinks } from "../profileSidebarLinks.js";
import { useState } from "react";
import { FaEdit, FaExpeditedssl, FaPlus, FaUserEdit } from "react-icons/fa";
import CustomInput from "../component/reusable/CustomInput.js";
import ButtonLoader from "../component/reusable/ButtonLoader.js";
import CustomButton from "../component/reusable/CustomButton.js";
import CustomTextarea from "../component/reusable/CustomTextarea.js";
import CustomSelect from "../component/reusable/CustomSelect.js";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { TiTick } from "react-icons/ti";
import { RxCross2 } from "react-icons/rx";
import userService from "../services/userService.js";
import Loader from "../component/reusable/Loader.js";
import GptLayout from "../component/gptLayout.js";

const StudentPiq = () => {
  const [editable, setEditable] = useState(false);
  const [myPIQ, setMyPIQ] = useState(null);
  const [loading, setLoading] = useState(false);
  const [createPIQLoading, setCreatePIQLoading] = useState(false);

  console.log("myPIQ", myPIQ);

  const [piqFormData, setPiqFormData] = useState({
    fullName: "",
    address: "",
    familiyIncome: "",
    height: "",
    weight: "",
    SSBRecord: "",
  });

  // INPUT CHNAGE HANDLER
  const handleInputChange = (e) => {
    const { value, name } = e.target;
    setPiqFormData({
      ...piqFormData,
      [name]: value,
    });
  };

  // QUALIFICATION DETAILS START
  const [addMoreQualification, setAddMoreQualification] = useState(true);
  const [editEducation, setEditEducation] = useState(false);
  const [editEduIndex, setEditEduIndex] = useState("");
  const [qualifications, setQualifications] = useState([]);
  const [educationObj, setEducationObj] = useState({
    grade: "",
    obtainedPercentage: "",
    passingYear: "",
  });

  const handleEduInputChange = (e) => {
    const { value, name } = e.target;
    setEducationObj({
      ...educationObj,
      [name]: value,
    });
  };

  // Initiate Edit Function
  const handleEditInitiate = (index) => {
    setEditEduIndex(index); // set selected index in the state
    const data = qualifications.find((_, i) => i === index);
    setEducationObj({
      grade: data?.grade,
      obtainedPercentage: data?.obtainedPercentage,
      passingYear: data?.passingYear,
    });
    setAddMoreQualification(false);
    setEditEducation(true);
  };

  // normalize initated edit function
  const handleNormaliseEditInitiate = () => {
    setEditEduIndex(""); // blank the state
    setEducationObj({
      grade: "",
      obtainedPercentage: "",
      passingYear: "",
    });
    setEditEducation(false);
  };

  // Edit/Update Qualification in list
  const handleUpdateEdu = (index) => {
    const updatedQualifications = qualifications.map((item, i) =>
      i === index ? educationObj : item
    );
    setQualifications(updatedQualifications);
    setEducationObj({
      grade: "",
      obtainedPercentage: "",
      passingYear: "",
    });
    setEditEducation(false);
  };

  // Delete Qualification from list
  const handleDeleteEdu = (index) => {
    const updatedQualifications = qualifications.filter((_, i) => i !== index);
    setQualifications(updatedQualifications);
  };

  // Add Qualification in list
  const handleAddQualification = () => {
    if (!educationObj.grade) {
      toast.warning("Please fill Grade/Education Title");
    } else if (!educationObj.obtainedPercentage) {
      toast.warning("Please fill obtained percentage");
    } else if (!educationObj.passingYear) {
      toast.warning("Please fill passing year");
    } else {
      setQualifications([...qualifications, educationObj]);
      setEducationObj({
        grade: "",
        obtainedPercentage: "",
        passingYear: "",
      });
      // setAddMoreQualification(false); // Close Add More inputs
    }
  };
  // QUALIFICATION DETAILS ENDS

  // HOBBIES AND INTEREST START
  const [addMoreHobbies, setAddMoreHobbies] = useState(true);
  const [editHobbies, setEditHobbies] = useState(false);
  const [editHobbyIndex, setEditHobbyIndex] = useState("");
  const [hobbies, setHobbies] = useState([]);
  const [hobbyString, setHobbyString] = useState("");

  // Initiate Edit Hobby Function
  const handleEditHobbyInitiate = (index) => {
    setEditHobbyIndex(index); // set selected index in the state
    const data = hobbies.find((_, i) => i === index);
    setHobbyString(data); // set data in hobby string
    setAddMoreHobbies(false);
    setEditHobbies(true);
  };

  // normalize initated edit Hobby function
  const handleNormaliseEditHobbyInitiate = () => {
    setEditHobbyIndex(""); // blank the state
    setHobbyString("");
    setEditHobbies(false);
  };

  // Edit/Update Qualification in list
  const handleUpdateHobby = (index) => {
    const updatedHobbies = hobbies.map((item, i) =>
      i === index ? hobbyString : item
    );
    setHobbies(updatedHobbies);
    setHobbyString("");
    setEditHobbies(false);
  };

  // Delete Qualification from list
  const handleDeleteHobby = (index) => {
    const updatedHobbies = hobbies.filter((_, i) => i !== index);
    setHobbies(updatedHobbies);
  };

  // Add Qualification in list
  const handleAddNewHobby = () => {
    if (!hobbyString) {
      toast.warning("Please fill hobby/Interest");
    } else {
      setHobbies([...hobbies, hobbyString]);
      setHobbyString("");
      //   setAddMoreHobbies(false); // Close Add More inputs
    }
  };
  // HOBBIES AND INTEREST ENDS

  // SPORTS FUNCTIONALITY START
  const [addMoreSports, setAddMoreSports] = useState(true);
  const [editSports, setEditSports] = useState(false);
  const [editSportsIndex, setEditSportsIndex] = useState("");
  const [sports, setSports] = useState([]);
  const [sportString, setSportString] = useState("");

  // Initiate Edit Sport Function
  const handleEditSportsInitiate = (index) => {
    setEditSportsIndex(index); // set selected index in the state
    const data = sports.find((_, i) => i === index);
    setSportString(data); // set data in Sport string
    setAddMoreSports(false);
    setEditSports(true);
  };

  // normalize initated edit Sport function
  const handleNormaliseEditSportInitiate = () => {
    setEditSportsIndex(""); // blank the state
    setSportString("");
    setEditSports(false);
  };

  // Edit/Update Qualification in list
  const handleUpdateSports = (index) => {
    const updatedSports = sports.map((item, i) =>
      i === index ? sportString : item
    );
    setSports(updatedSports);
    setSportString("");
    setEditSports(false);
  };

  // Delete Qualification from list
  const handleDeleteSport = (index) => {
    const updatedSports = sports.filter((_, i) => i !== index);
    setSports(updatedSports);
  };

  // Add Qualification in list
  const handleAddNewSport = () => {
    if (!sportString) {
      toast.warning("Please fill in the input box");
    } else {
      setSports([...sports, sportString]);
      setSportString("");
      //   setAddMoreSports(false); // Close Add More inputs
      toast.success("New data added in list");
    }
  };
  // SPORTS FUNCTIONALITY ENDS

  // GET MY PIQ STARTS
  async function fetchPIQ() {
    setLoading(true);
    try {
      const result = await userService.myPIQ();
      if (result?.data?.piq) {
        setMyPIQ(result.data.piq);
        setPiqFormData({
          fullName: result.data.piq?.fullName,
          address: result.data.piq?.address,
          familiyIncome: result.data.piq?.familiyIncome,
          height: result.data.piq?.height,
          weight: result.data.piq?.weight,
          SSBRecord: result.data.piq?.SSBRecord,
        });
        setHobbies(result.data.piq?.hobbyAndInterest);
        setSports(result.data.piq?.sports);
        setQualifications(result.data.piq?.qualifications);
      } else {
        console.warn("No PIQ data found in response.");
        setMyPIQ(null); // Reset if no data
      }
    } catch (error) {
      console.error("Error fetching PIQ:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchPIQ();
  }, []);
  // GET MY PIQ ENDS

  // UPDATE/CREATE PIQ START
  const handleUpdatePIQ = async () => {
    setCreatePIQLoading(true);
    try {
      let result = await userService.updatePIQ({
        fullName: piqFormData.fullName,
        address: piqFormData.address,
        familiyIncome: piqFormData.familiyIncome,
        height: piqFormData.height,
        weight: piqFormData.weight,
        SSBRecord: piqFormData.SSBRecord,
        hobbies,
        sports,
        qualifications,
      });

      if (result?.data?.success) {
        toast.success("PIQ Updated Successfully");
        setEditable(false); // All Inputs Edit False
        setEditEducation(false); // Education Edit False
        setEditHobbies(false); // Hobbies Edit False
        setEditSports(false); // Sports Edit False
        result = {}; // 
        fetchPIQ();
      }
    } catch (error) {
      console.error("Error updating PIQ:", error);
      setCreatePIQLoading(false);
    } finally {
      setCreatePIQLoading(false);
    }
  };
  // UPDATE/CREATE PIQ ENDS

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <GptLayout>
          <StudentLayout sidebarLinks={studentSidebarLinks}>
            <section className="student_profile_section student_piq_main txt_color">
              <h2 className="profilePage_heading">
                Personal Information Questionnaire
              </h2>

              <div className="user_details_main">
                <div className="user_pro_data">
                  <h2>
                    PIQ{" "}
                    <button
                      className={editable ? "activeBtn" : ""}
                      onClick={() => setEditable(!editable)}
                    >
                      {editable ? <FaExpeditedssl /> : <FaUserEdit />} Edit
                    </button>
                  </h2>
                  <div>
                    <div className="details_sec">
                      <div className="data_card">
                        <CustomInput
                          label="Full Name"
                          type="text"
                          placeholder="Full Name"
                          impStar={editable ? "*" : ""}
                          name="fullName"
                          value={piqFormData?.fullName}
                          readOnly={editable ? false : true}
                          onChange={handleInputChange}
                          borderColor={editable ? "#f2f2f2" : ""}
                        />
                        <CustomInput
                          label="Total Familiy Income (in Rupees)"
                          type="number"
                          impStar={editable ? "*" : ""}
                          placeholder="Total Familiy Income"
                          name="familiyIncome"
                          value={piqFormData?.familiyIncome}
                          readOnly={editable ? false : true}
                          onChange={handleInputChange}
                          borderColor={editable ? "#f2f2f2" : ""}
                        />
                        <CustomInput
                          label="Height (in Meters)"
                          type="number"
                          impStar={editable ? "*" : ""}
                          placeholder="Height (in Meters)"
                          name="height"
                          value={piqFormData?.height}
                          readOnly={editable ? false : true}
                          onChange={handleInputChange}
                          borderColor={editable ? "#f2f2f2" : ""}
                        />
                        <CustomInput
                          label="Weight (in Kgs)"
                          type="number"
                          impStar={editable ? "*" : ""}
                          placeholder="Weight (in Kgs)"
                          name="weight"
                          value={piqFormData?.weight}
                          readOnly={editable ? false : true}
                          onChange={handleInputChange}
                          borderColor={editable ? "#f2f2f2" : ""}
                        />
                        <CustomTextarea
                          label="Address (Present Address)"
                          type="number"
                          impStar={editable ? "*" : ""}
                          placeholder="Enter Your Present Address"
                          name="address"
                          value={piqFormData?.address}
                          readOnly={editable ? false : true}
                          onChange={handleInputChange}
                          borderColor={editable ? "#f2f2f2" : ""}
                          rows={3}
                          fullWidth={true}
                        />
                        <CustomSelect
                          label="SSB Record"
                          type="number"
                          impStar={editable ? "*" : ""}
                          name="SSBRecord"
                          value={piqFormData?.SSBRecord}
                          readOnly={editable ? false : true}
                          onChange={handleInputChange}
                          borderColor={editable ? "#f2f2f2" : ""}
                          fullWidth={true}
                          optionArray={[
                            { option: "Fresher" },
                            { option: "Screen Out" },
                            { option: "Conference Out" },
                            { option: "Recommended" },
                          ]}
                        />

                        {/* QUALIFICATION SECTION START */}
                        <div className="tableOfPiq">
                          <div className="heading">
                            <span>
                              Qualifications{" "}
                              {editable && (
                                <abbr style={{ color: "red" }}>*</abbr>
                              )}
                            </span>
                            {editable && (
                              <span
                                title="Add More Qualifications"
                                onClick={() => {
                                  handleNormaliseEditInitiate();
                                  setAddMoreQualification(
                                    !addMoreQualification
                                  );
                                }}
                                className="buttonSpan"
                              >
                                <FaPlus
                                  style={{
                                    transform: addMoreQualification
                                      ? "rotate(45deg)"
                                      : "",
                                  }}
                                />{" "}
                                Add More
                              </span>
                            )}
                          </div>
                          <div className="overflowSection">
                            <table>
                              <thead>
                                <tr>
                                  <th>Grade Level</th>
                                  <th>Marks (Obtained Percentage)</th>
                                  <th>Passing Year</th>
                                  {editable && <th>Action</th>}
                                </tr>
                              </thead>
                              <tbody>
                                {qualifications?.map((item, itemIndex) => (
                                  <tr key={"qualification" + itemIndex}>
                                    <td>
                                      <input
                                        readOnly={
                                          editEducation &&
                                          editEduIndex === itemIndex
                                            ? false
                                            : true
                                        }
                                        style={{
                                          border:
                                            editEducation &&
                                            editEduIndex === itemIndex
                                              ? "1px solid red"
                                              : "",
                                        }}
                                        type="text"
                                        value={
                                          editEducation &&
                                          editEduIndex === itemIndex
                                            ? educationObj?.grade
                                            : item?.grade
                                        }
                                        onChange={handleEduInputChange}
                                        name="grade"
                                        placeholder="Ex: 10th/12th/B.Sc"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        readOnly={
                                          editEducation &&
                                          editEduIndex === itemIndex
                                            ? false
                                            : true
                                        }
                                        style={{
                                          border:
                                            editEducation &&
                                            editEduIndex === itemIndex
                                              ? "1px solid red"
                                              : "",
                                        }}
                                        type="number"
                                        value={
                                          editEducation &&
                                          editEduIndex === itemIndex
                                            ? educationObj?.obtainedPercentage
                                            : item?.obtainedPercentage
                                        }
                                        onChange={handleEduInputChange}
                                        name="obtainedPercentage"
                                        placeholder="Ex: 85.3"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        readOnly={
                                          editEducation &&
                                          editEduIndex === itemIndex
                                            ? false
                                            : true
                                        }
                                        style={{
                                          border:
                                            editEducation &&
                                            editEduIndex === itemIndex
                                              ? "1px solid red"
                                              : "",
                                        }}
                                        type="number"
                                        value={
                                          editEducation &&
                                          editEduIndex === itemIndex
                                            ? educationObj?.passingYear
                                            : item?.passingYear
                                        }
                                        onChange={handleEduInputChange}
                                        name="passingYear"
                                        placeholder="Ex: 2024"
                                      />
                                    </td>
                                    {editable && (
                                      <td>
                                        <div className="buttonGrp">
                                          {editEducation &&
                                          editEduIndex === itemIndex ? (
                                            <>
                                              <button
                                                title="Update Now"
                                                onClick={() =>
                                                  handleUpdateEdu(itemIndex)
                                                }
                                                className="editBtn"
                                                style={{ color: "green" }}
                                              >
                                                <TiTick />
                                              </button>
                                              <button
                                                title="Cancel"
                                                onClick={() =>
                                                  handleNormaliseEditInitiate()
                                                }
                                                className="deleteBtn"
                                                style={{ color: "red" }}
                                              >
                                                <RxCross2 />
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                title="Edit/Update"
                                                onClick={() =>
                                                  handleEditInitiate(itemIndex)
                                                }
                                                className="editBtn"
                                              >
                                                <FaEdit />
                                              </button>
                                              <button
                                                title="Remove/Delete"
                                                onClick={() =>
                                                  handleDeleteEdu(itemIndex)
                                                }
                                                className="deleteBtn"
                                              >
                                                <MdDelete />
                                              </button>
                                            </>
                                          )}
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                                {addMoreQualification && editable && (
                                  <tr key="qualificationCreate">
                                    <td>
                                      <input
                                        type="text"
                                        value={educationObj?.grade}
                                        onChange={handleEduInputChange}
                                        name="grade"
                                        placeholder="Ex: 10th/12th/B.Sc"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={educationObj?.obtainedPercentage}
                                        onChange={handleEduInputChange}
                                        name="obtainedPercentage"
                                        placeholder="Ex: 85.3"
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={educationObj?.passingYear}
                                        onChange={handleEduInputChange}
                                        name="passingYear"
                                        placeholder="Ex: 2024"
                                      />
                                    </td>
                                    <td>
                                      <button onClick={handleAddQualification}>
                                        <TiTick /> Add
                                      </button>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {/* QUALIFICATION SECTION ENDS */}

                        {/* HOBBY AND INTEREST START */}
                        <div className="tableOfPiq">
                          <div className="heading">
                            <span>
                              Hobby & Interest{" "}
                              {editable && (
                                <abbr style={{ color: "red" }}>*</abbr>
                              )}
                            </span>
                            {editable && (
                              <span
                                title="Add More Hobbies"
                                onClick={() => {
                                  handleNormaliseEditHobbyInitiate();
                                  setAddMoreHobbies(!addMoreHobbies);
                                }}
                                className="buttonSpan"
                              >
                                <FaPlus
                                  style={{
                                    transform: addMoreHobbies
                                      ? "rotate(45deg)"
                                      : "",
                                  }}
                                />{" "}
                                Add More
                              </span>
                            )}
                          </div>
                          <div className="overflowSection">
                            <table>
                              <thead>
                                <tr>
                                  <th>Hobby (Interest In)</th>
                                  {editable && <th>Action</th>}
                                </tr>
                              </thead>
                              <tbody>
                                {hobbies?.map((item, itemIndex) => (
                                  <tr key={"hobby" + itemIndex}>
                                    <td>
                                      <input
                                        readOnly={
                                          editHobbies &&
                                          editHobbyIndex === itemIndex
                                            ? false
                                            : true
                                        }
                                        style={{
                                          border:
                                            editHobbies &&
                                            editHobbyIndex === itemIndex
                                              ? "1px solid red"
                                              : "",
                                        }}
                                        type="text"
                                        value={
                                          editHobbies &&
                                          editHobbyIndex === itemIndex
                                            ? hobbyString
                                            : item
                                        }
                                        onChange={(e) =>
                                          setHobbyString(e.target.value)
                                        }
                                        name="hobbyString"
                                        placeholder="Ex: Reading Books"
                                      />
                                    </td>
                                    {editable && (
                                      <td>
                                        <div className="buttonGrp">
                                          {editHobbies &&
                                          editHobbyIndex === itemIndex ? (
                                            <>
                                              <button
                                                title="Update Now"
                                                onClick={() =>
                                                  handleUpdateHobby(itemIndex)
                                                }
                                                className="editBtn"
                                                style={{ color: "green" }}
                                              >
                                                <TiTick />
                                              </button>
                                              <button
                                                title="Cancel"
                                                onClick={() =>
                                                  handleNormaliseEditHobbyInitiate()
                                                }
                                                className="deleteBtn"
                                                style={{ color: "red" }}
                                              >
                                                <RxCross2 />
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                title="Edit/Update"
                                                onClick={() =>
                                                  handleEditHobbyInitiate(
                                                    itemIndex
                                                  )
                                                }
                                                className="editBtn"
                                              >
                                                <FaEdit />
                                              </button>
                                              <button
                                                title="Remove/Delete"
                                                onClick={() =>
                                                  handleDeleteHobby(itemIndex)
                                                }
                                                className="deleteBtn"
                                              >
                                                <MdDelete />
                                              </button>
                                            </>
                                          )}
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                                {addMoreHobbies && editable && (
                                  <tr key="hobbyCreate">
                                    <td>
                                      <input
                                        type="text"
                                        value={hobbyString}
                                        onChange={(e) =>
                                          setHobbyString(e.target.value)
                                        }
                                        name="hobbyString"
                                        placeholder="Ex: Reading Books"
                                      />
                                    </td>
                                    <td>
                                      <button onClick={handleAddNewHobby}>
                                        <TiTick /> Add
                                      </button>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {/* HOBBY AND INTEREST ENDS */}

                        {/* SPORTS SECTION START */}
                        <div className="tableOfPiq">
                          <div className="heading">
                            <span>
                              Sports{" "}
                              {editable && (
                                <abbr style={{ color: "red" }}>*</abbr>
                              )}
                            </span>
                            {editable && (
                              <span
                                title="Add More Sports"
                                onClick={() => {
                                  handleNormaliseEditSportInitiate();
                                  setAddMoreSports(!addMoreSports);
                                }}
                                className="buttonSpan"
                              >
                                <FaPlus
                                  style={{
                                    transform: addMoreSports
                                      ? "rotate(45deg)"
                                      : "",
                                  }}
                                />{" "}
                                Add More
                              </span>
                            )}
                          </div>
                          <div className="overflowSection">
                            <table>
                              <thead>
                                <tr>
                                  <th>Sports</th>
                                  {editable && <th>Action</th>}
                                </tr>
                              </thead>
                              <tbody>
                                {sports?.map((item, itemIndex) => (
                                  <tr key={"sport" + itemIndex}>
                                    <td>
                                      <input
                                        readOnly={
                                          editSports &&
                                          editSportsIndex === itemIndex
                                            ? false
                                            : true
                                        }
                                        style={{
                                          border:
                                            editSports &&
                                            editSportsIndex === itemIndex
                                              ? "1px solid red"
                                              : "",
                                        }}
                                        type="text"
                                        value={
                                          editSports &&
                                          editSportsIndex === itemIndex
                                            ? sportString
                                            : item
                                        }
                                        onChange={(e) =>
                                          setSportString(e.target.value)
                                        }
                                        name="sportString"
                                        placeholder="Ex: Cricket/Football"
                                      />
                                    </td>
                                    {editable && (
                                      <td>
                                        <div className="buttonGrp">
                                          {editSports &&
                                          editSportsIndex === itemIndex ? (
                                            <>
                                              <button
                                                title="Update Now"
                                                onClick={() =>
                                                  handleUpdateSports(itemIndex)
                                                }
                                                className="editBtn"
                                                style={{ color: "green" }}
                                              >
                                                <TiTick />
                                              </button>
                                              <button
                                                title="Cancel"
                                                onClick={() =>
                                                  handleNormaliseEditSportInitiate()
                                                }
                                                className="deleteBtn"
                                                style={{ color: "red" }}
                                              >
                                                <RxCross2 />
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                title="Edit/Update"
                                                onClick={() =>
                                                  handleEditSportsInitiate(
                                                    itemIndex
                                                  )
                                                }
                                                className="editBtn"
                                              >
                                                <FaEdit />
                                              </button>
                                              <button
                                                title="Remove/Delete"
                                                onClick={() =>
                                                  handleDeleteSport(itemIndex)
                                                }
                                                className="deleteBtn"
                                              >
                                                <MdDelete />
                                              </button>
                                            </>
                                          )}
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                                {addMoreSports && editable && (
                                  <tr key="sportCreate">
                                    <td>
                                      <input
                                        type="text"
                                        value={sportString}
                                        onChange={(e) =>
                                          setSportString(e.target.value)
                                        }
                                        name="sportString"
                                        placeholder="Ex: Cricket/Football"
                                      />
                                    </td>
                                    <td>
                                      <button onClick={handleAddNewSport}>
                                        <TiTick /> Add
                                      </button>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {/* SPORTS SECTION ENDS */}

                        {editable && (
                          <CustomButton
                            className="pro_update_btn"
                            title={
                              createPIQLoading ? (
                                <ButtonLoader color="#f3ad6c" />
                              ) : (
                                `Update`
                              )
                            }
                            // disabled={createPIQLoading}
                            width="100px"
                            onClick={handleUpdatePIQ}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </StudentLayout>
        </GptLayout>
      )}
    </Fragment>
  );
};

export default StudentPiq;
